export function isMobile() {
  return !!navigator.userAgent.match(/iPhone|iPad|Android.+Mobile/) ||

    // iPad もモバイルとして扱う（https://uv-jp.slack.com/archives/C9WP087R7/p1689672671058599）
    (!!navigator.userAgent.match(/Macintosh/) && 'ontouchend' in document);
}
